<template>
  <div>
    <div v-for="(item, index) in list" class="item">
      <div class="number-index">{{index+1}}、</div>
      <div>
        中文:
        <el-input v-model="item.title" style="width: 400px; margin-bottom: 10px;" placeholder="请输入标题"></el-input>
      </div>
      <div>
        英文:
        <el-input v-model="item.title_en" style="width: 400px; margin-bottom: 10px;" placeholder="请输入标题"></el-input>
      </div>
      <div style="margin-bottom: 10px;">
        <img v-if="item.image" class="thumb cursor-pointer" :src="item.image" title="点击更换" @click="selectThumb(item)">
        <div v-else class="addimg" @click="selectThumb(item)">+</div>
      </div>

      <!-- <UploadImages v-model="item.image"></UploadImages> -->

      <div style="margin-bottom: 10px;">

        <el-select v-model="item.type">
          <el-option value="html" label="HTML类型"></el-option>
          <el-option value="path" label="路径跳转"></el-option>
        </el-select>

        <el-input v-if="item.type === 'path'" style="width: 600px;" v-model="item.path" placeholder="请输入跳转路径"></el-input>
        <div v-else>
          中文
          <RichText class="rich-text-editor" v-model="item.html"></RichText>
          英文
          <RichText class="rich-text-editor" v-model="item.html_en"></RichText>
        </div>

        <!-- <el-button v-else type="primary" size="small" @click="editHtml(item)">点击编辑富文本</el-button> -->
      </div>


      <el-button size="small" @click="addItem(index)">添加</el-button>
      <el-button size="small" @click="deleteItem(index)">删除</el-button>
      <el-button size="small" @click="toUp(index)">向上移</el-button>
      <el-button size="small" @click="toDown(index)">向下移</el-button>

    </div>

    <el-button size="small" @click="addItem">添加一组</el-button>

    <!-- 编辑富文本 -->
    <!-- <el-dialog title="编辑富文本" :visible.sync="imageComVisible" width="1110px">
      <RichText v-model=""></RichText>
    </el-dialog> -->

    <el-button type="primary" style="float:right;" @click="saveForm">提交保存</el-button>

    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>

  </div>
</template>
<script>
import RichText from '@/components/RichText'

import UploadImg from '@/components/UploadImg'

export default {
  components: {
    RichText,
    UploadImg
  },
  props: {
    com: {
      type: [Array]
    }
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    com: {
      handler(newVal, oldVal) {
        console.log('val 变化', newVal)
        this.list = newVal || []
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    toUp(index) {
      if (index === 0) return
      let current = JSON.parse(JSON.stringify(this.list[index]))
      let pre = JSON.parse(JSON.stringify(this.list[index - 1]))
      this.list.splice(index, 1, pre)
      this.list.splice(index - 1, 1, current)
    },
    toDown(index) {
      if (index === this.list.length - 1) return
      let current = JSON.parse(JSON.stringify(this.list[index]))
      let next = JSON.parse(JSON.stringify(this.list[index + 1]))
      this.list.splice(index, 1, next)
      this.list.splice(index + 1, 1, current)
    },
    addItem (index) {
      let obj = {
        type: 'path',
        image: '',
        path: '',
        html: '',
        title: ''
      }
      if (index === null) {
        this.list.push(obj)
      }
      else {
        this.list.splice(index + 1, 0, obj)
      }
    },
    deleteItem (index) {
      this.list.splice(index, 1)
    },
    saveForm() {
      console.log(this.list)

      this.$emit('save', this.list)
    },
    selectThumb (item) {
      let list = []
      if (item.image) {
        list = [item.image]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          item.image = res[0]
        }
      }).catch()
    }
  }
}
</script>

<style lang="scss" scoped>
.rich-text-editor {
  width: 600px;
}

.item {
  padding-left: 20px;
  position: relative;
  margin-bottom: 20px;
  border: 1px solid #e1e1e1;
  padding: 10px 30px;
}

.number-index {
  position: absolute;
  left: 10px;
  top: 10px;
}


.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
}
.list {
  margin-top: 20px;
  width: 700px;
  .item {
    margin-bottom: 20px;
    padding: 10px 20px;
    background-color: #f8f8f8;
    /deep/ .el-form-item {
      margin-bottom: 8px;
    }
  }
  .add-btn {
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    border-radius: 5px;
    border: 1px dashed #dddddd;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ImageCom/index.vue